import { render, staticRenderFns } from "./App.vue?vue&type=template&id=42899320&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style1 from "./App.vue?vue&type=style&index=1&id=42899320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42899320",
  null
  
)

export default component.exports